import React from 'react'

import { useFetch } from 'hooks'

// NOTE: hook that exposes server data for other
// local hooks and interviews components
export const useData = (state, handlers) => {
  const { uuid } = state
  const { handleFetchInterview } = handlers

  const handleFetch = React.useCallback(
    async () => await handleFetchInterview({ uuid }),
    [uuid, handleFetchInterview],
  )

  const {
    state: { error, meta, response, isFetching },
    handlers: { handleSetResponse },
  } = useFetch(handleFetch)

  return {
    state: {
      error,
      meta,
      response,
      isFetching,
    },
    handlers: {
      handleFetch,
      handleSetResponse,
    },
  }
}
